"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Meeting = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_entity_1 = require("./company.entity");
const look_up_entity_1 = require("./look-up.entity");
const meeting_document_map_entity_1 = require("./meeting-document-map.entity");
const meeting_participants_entity_1 = require("./meeting-participants.entity");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const opportunity_entity_1 = require("./opportunity.entity");
let Meeting = class Meeting {
    constructor(opportunityId, activityId, meetingTypeLid, meetingStatusLid, companyId, meetingDate, startTime, duration, endTime, locationTypeLid, meetingSubject, meetingAgenda) {
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.meetingTypeLid = meetingTypeLid;
        this.meetingStatusLid = meetingStatusLid;
        this.companyId = companyId;
        this.meetingDate = meetingDate;
        this.startTime = startTime;
        this.duration = duration;
        this.endTime = endTime;
        this.locationTypeLid = locationTypeLid;
        this.meetingSubject = meetingSubject;
        this.meetingAgenda = meetingAgenda;
    }
};
exports.Meeting = Meeting;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "meetingTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_date", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Meeting.prototype, "meetingDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "start_time", type: "timetz", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Meeting.prototype, "startTime", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "duration", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "end_time", type: "timetz", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], Meeting.prototype, "endTime", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "location_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "locationTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "meeting_subject",
        type: "varchar",
        length: 255,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], Meeting.prototype, "meetingSubject", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_agenda", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Meeting.prototype, "meetingAgenda", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "meetingStatusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], Meeting.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], Meeting.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({
        name: "deleted_at",
        type: "timestamptz",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], Meeting.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Meeting.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_k = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _k : Object)
], Meeting.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_activity_map_entity_1.OpportunityActivityMap),
    (0, typeorm_1.JoinColumn)({ name: "activity_id" }),
    tslib_1.__metadata("design:type", typeof (_l = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _l : Object)
], Meeting.prototype, "activity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", typeof (_m = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _m : Object)
], Meeting.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "meeting_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_o = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _o : Object)
], Meeting.prototype, "meetingType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "meeting_status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_p = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _p : Object)
], Meeting.prototype, "meetingStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "location_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_q = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _q : Object)
], Meeting.prototype, "location", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => meeting_participants_entity_1.MeetingParticipantMap, (meetingParticipantMap) => meetingParticipantMap.meeting, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], Meeting.prototype, "participants", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => meeting_document_map_entity_1.MeetingDocumentMap, (meetingDoc) => meetingDoc.meeting),
    tslib_1.__metadata("design:type", Array)
], Meeting.prototype, "meetingDocs", void 0);
exports.Meeting = Meeting = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "meeting" }),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, Number, String, String])
], Meeting);
